import { lazy } from 'react';

const Avatar = lazy(() => import('./Avatar'));

export { Avatar };
